import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from './sheet'

interface ResizableDrawerMobileProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  title: string
  description: string
  children: ReactNode
  className?: string
}

/**
 * Generic mobile drawer shell using Shadcn Sheet.
 * Slides in from the right as a full-width sheet.
 */
export const ResizableDrawerMobile = ({
  isOpen,
  onOpenChange,
  title,
  description,
  children,
  className,
}: ResizableDrawerMobileProps): ReactNode => (
  <Sheet open={isOpen} onOpenChange={onOpenChange}>
    <SheetContent
      className={cn('resizable-drawer-mobile flex w-full flex-col p-0 sm:max-w-lg', className)}
    >
      <SheetHeader className="sr-only">
        <SheetTitle>{title}</SheetTitle>
        <SheetDescription>{description}</SheetDescription>
      </SheetHeader>
      {children}
      <SheetFooter className="sr-only" />
    </SheetContent>
  </Sheet>
)

ResizableDrawerMobile.displayName = 'ResizableDrawerMobile'
